// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2h5tp","list":"BalanceDue_list__3Zz3H","listRow":"BalanceDue_listRow__2P1Fp","total":"BalanceDue_total__321QR"};